/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment } from 'react'

// css
import { observer } from 'mobx-react'
import FirstBet from './FirstBet'
import GuideNotice from './GuideNotice'
import AchieveGoal from './AchieveGoal'
import GuideComplete from './GuideComplete'


const GuidePopup: React.FC = props => {

  return (
    <Fragment>
      <GuideNotice />
      <FirstBet />
      <AchieveGoal />
      <GuideComplete />
    </Fragment>
  )
}

export default observer(GuidePopup)
